import type { Mission } from '../missions.ts'

export const usfs: Mission = {
  id: "usfs",
  name: "U.S. Forest Service",
  short: "USFS",
  call: "Forests",
  kind: "subagency",
  parent: "usda",
  url: "https://www.fs.usda.gov/",
  established: 1905,
  palette: {
    primary: "#154c21",
    secondary: "#322d26",
    accent: "#e5a000",
  },
  colorSource: {
    kind: "site",
    url: "https://www.fs.usda.gov/",
  },
  motif: "pine",
  mission: {
    text: "The mission of the Forest Service is to sustain the health, diversity, and productivity of the nation's forests and grasslands to meet the needs of present and future generations.",
    url: "https://www.fs.usda.gov/about-agency/meet-forest-service",
  },
  fact: {
    text: "Gifford Pinchot was the first Chief of the Forest Service, which took charge of the federal forest reserves in 1905.",
    url: "https://www.fs.usda.gov/learn/our-history",
  },
  seal: {
    file: "public/seals/usfs.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Forest_Service.svg",
  },
  identifier: {
    about: "https://www.fs.usda.gov/about-agency",
    accessibility: "https://www.usda.gov/accessibility-statement",
    foia: "https://www.fs.usda.gov/about-agency/foia",
    noFear: "https://www.fs.usda.gov/about-agency/civil-rights#noFEARAct",
    oig: "https://usdaoig.oversight.gov/",
    performance: "https://www.fs.usda.gov/about-agency/budget-performance",
    privacy: "https://www.usda.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/usfs-lost-lake.jpg",
        small: "/media/usfs-lost-lake-sm.jpg",
        alt: "Golden sunset light breaking through clouds above a forested shoreline and the calm water of Lost Lake.",
        title: "Clouds during sunset at Lost Lake, Mount Hood National Forest, Oregon",
        creator: "Cecilio Ricardo, USDA Forest Service",
        source: "https://commons.wikimedia.org/wiki/File:20190923-MountHood-CMR-0761a_(48871189723).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usfs-mount-st-helens.jpg",
        small: "/media/usfs-mount-st-helens-sm.jpg",
        alt: "Snow-capped Mount St. Helens above the Toutle River valley, with a weathered tree stump and young conifers in the foreground.",
        title: "Coldwater Ridge and Toutle River, Mount St. Helens National Volcanic Monument, Gifford Pinchot National Forest",
        creator: "U.S. Forest Service, Pacific Northwest Region",
        source: "https://commons.wikimedia.org/wiki/File:Gifford_Pinchot_National_Forest,_Mt_St_Helens_NVM,_Coldwater_Ridge_and_Toutle_River_(36361246123).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
